export const musicList4 = [
  {
    title: "휴식",
    id: "rest1",
    photo: "https://dongsooo.github.io/imgs/img/04_rest-01.jpg",
    musicTitle: "Tanamur City - Indonesian AOR",
  },
  {
    id: "rest2",
    photo: "https://dongsooo.github.io/imgs/img/04_rest-02.jpg",
    musicTitle: "No vacation - Intermission",
  },
  {
    id: "rest3",
    photo: "https://dongsooo.github.io/imgs/img/04_rest-03.jpg",
    musicTitle: "No vacation - Dræm Girl",
  },
  {
    id: "rest4",
    photo: "https://dongsooo.github.io/imgs/img/04_rest-04.jpg",
    musicTitle: "freetempo - love affair",
  },
  {
    id: "rest5",
    photo: "https://dongsooo.github.io/imgs/img/04_rest-05.JPG",
    musicTitle: "Milky Day - Am I Different",
  },
];
